"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Default data for `MaterialTable.options` attribute
 */
var _default = {
  idSynonym: 'id',
  actionsColumnIndex: 0,
  addRowPosition: 'last',
  columnsButton: false,
  detailPanelType: 'multiple',
  debounceInterval: 200,
  doubleHorizontalScroll: false,
  emptyRowsWhenPaging: true,
  exportAllData: false,
  exportMenu: [],
  filtering: false,
  groupTitle: false,
  header: true,
  headerSelectionProps: {},
  hideFilterIcons: false,
  loadingType: 'overlay',
  padding: 'normal',
  searchAutoFocus: false,
  paging: true,
  pageSize: 5,
  pageSizeOptions: [5, 10, 20],
  paginationType: 'normal',
  paginationPosition: 'bottom',
  showEmptyDataSourceMessage: true,
  showFirstLastPageButtons: true,
  showSelectAllCheckbox: true,
  showSelectGroupCheckbox: true,
  search: true,
  showTitle: true,
  showTextRowsSelected: true,
  showDetailPanelIcon: true,
  tableLayout: 'auto',
  tableWidth: 'full',
  toolbarButtonAlignment: 'right',
  searchFieldAlignment: 'right',
  searchFieldStyle: {},
  searchFieldVariant: 'standard',
  selection: false,
  selectionProps: {},
  // sorting: true,
  maxColumnSort: 1,
  groupChipProps: {},
  defaultOrderByCollection: [],
  showColumnSortOrder: false,
  keepSortDirectionOnColumnSwitch: true,
  toolbar: true,
  defaultExpanded: false,
  detailPanelColumnAlignment: 'left',
  detailPanelOffset: {
    left: 0,
    right: 0
  },
  thirdSortClick: true,
  overflowY: 'auto',
  numberOfPagesAround: 1,
  actionsHeaderIndex: 0,
  draggable: true
};
exports["default"] = _default;